export const RESET_CHATS = 'RESET_CHATS';
export const LOAD_CHATS_LIST = 'LOAD_CHATS_LIST';
export const LOAD_CHAT = 'LOAD_CHAT';
export const LOAD_TEMPLATES = 'LOAD_TEMPLATES';
export const ADD_TEMPLATE = 'ADD_TEMPLATE';
export const EDIT_TEMPLATE = 'EDIT_TEMPLATE';
export const DELETE_TEMPLATE = 'DELETE_TEMPLATE';
export const CHAT_SEND_MESSAGE = 'CHAT_SEND_MESSAGE';
export const CHAT_SEND_IMAGE = 'CHAT_SEND_IMAGE';
export const CHAT_SEARCH = 'CHAT_SEARCH';
export const CHAT_SEARCH_RESET = 'CHAT_SEARCH_RESET';
export const CLOSE_TICKET = 'CLOSE_TICKET';
export const HANDLE_BLACKLIST_USER = 'HANDLE_BLACKLIST_USER';
